import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/jpcars.webp';
import screenshot_target from '../../../images/letterfunnel/janwillemseeder.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jan-Willem Seeder"
      firstname="Jan-Willem"
      companyname="JP.cars"
      competition="Indicata en Autotelex"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/janwillemseeder.js